import "./ticketViewport.scss";

let owners = 0;
let restore: (() => void) | null = null;

/** Shared by nested screens/overlays so closing a menu cannot unlock a chat. */
export function acquireNativeScrollGuard(): () => void {
    if (!(window as any).ReactNativeWebView) return () => {};

    if (owners === 0) {
        const html = document.documentElement;
        const body = document.body;
        const previousPosition = { left: window.scrollX, top: window.scrollY };
        const previousHeight = body.style.getPropertyValue("--ticket-document-height");
        const keepOffset = () => {
            // Installed Android builds intercept downward gestures when the
            // outer WebView offset is <= 1, ignoring nested scroll containers.
            if (window.scrollY !== 2) window.scrollTo({ left: 0, top: 2, behavior: "auto" });
        };
        const updateHeight = () => {
            body.style.setProperty("--ticket-document-height", `${window.innerHeight + 4}px`);
            keepOffset();
        };

        html.classList.add("ticket-native-document");
        body.classList.add("ticket-native-document");
        window.addEventListener("scroll", keepOffset, { passive: true });
        window.addEventListener("resize", updateHeight);
        window.visualViewport?.addEventListener("resize", updateHeight);
        updateHeight();

        restore = () => {
            window.removeEventListener("scroll", keepOffset);
            window.removeEventListener("resize", updateHeight);
            window.visualViewport?.removeEventListener("resize", updateHeight);
            html.classList.remove("ticket-native-document");
            body.classList.remove("ticket-native-document");
            if (previousHeight) body.style.setProperty("--ticket-document-height", previousHeight);
            else body.style.removeProperty("--ticket-document-height");
            window.scrollTo({ ...previousPosition, behavior: "auto" });
        };
    }
    owners++;
    let released = false;
    return () => {
        if (released) return;
        released = true;
        if (--owners === 0) {
            restore?.();
            restore = null;
        }
    };
}
